import request, { storeRequest } from '@/libs/request';

export const getDataCenterInfoApi = (data) => request('getDataCenterInfo', data);
export const percentageCalculateApi = (data) =>
  request('/api/meetingCalculate/manager/percentageCalculate', data);

export const areaListApi = (data) => request('/api/meetingCalculate/manager/areaList', data);
export const managerMiniApi = (data) => request('/api/release/manager/mini', data);
export const exportArticlelStatisticsApi = (data) =>
  request('/api/data/center/exportArticlelStatistics', data);
export const exportExcelByArticleIdApi = (data) =>
  request('/api/vote/manager/exportExcelByArticleId', data);
export const exportTotalDailyDataApi = (data) =>
  request('/api/data/center/exportTotalDailyData', data);
export const queryHospitalInfoApi = (data) => request('HospitalDetail', data);
export const queryDoctorInfoByHospital = (data) => request('QueryDoctorInfoByHospital', data);
// 医生基本信息
export const doctorInfoApi = (data) => request('DoctorInfo', data);
// 医生行为信息
export const behavioralDataApi = (data) => request('DoctorBehaviour', data);

/**
 * 文章数据api
 */
/* 每日明细数据列表 */
export const getArticleStatByDayApi = (data) => request('GetArticleStatByDay', data);
/* 获取公众号/小程序列表 */
export const getAppListApi = (data) => request('GetArticleAppList', data);
/* 获取阅读、转发、收藏、发布总量 */
export const getArticleTotalCountApi = (data) => request('GetArticleTotalCount', data);
/* 单篇文章数据明细列表 */
export const getArticleStatDetailApi = (data) => request('GetArticleStatDetail', data);
export const getArticlePublishLogDetail = (data) => request('GetArticlePublishLogDetail', data);

// 用户数据
export const GetUserStatPages = (data) => request('GetUserStatPages', data);
export const GetUserStatByDay = (data) => request('GetUserStatByDay', data);
export const GetUserBehaviorList = (data) => request('GetUserBehaviorList', data);
export const GetBehaviorTypeList = (data) => request('GetBehaviorTypeList', data);
export const GetUserTypeList = (data) => request('GetUserTypeList', data);
export const GetKvList = (data) => request('GetKvList', data);
export const getAppList = (data) => request('ListAppBusiness', data); // 用户来源

/**
 * 会议数据api
 */
// 获取会议关键统计数据
export const getMeetingStatPagesApi = (data) => request('GetMeetingStatPages', data);
// 获取会议类型列表
export const getMeetingTypeListApi = (data) =>
  storeRequest(
    {
      cmd: 'GetMeetingTypes',
      payload: data,
    },
    { key: 'GetMeetingTypes', cache: true },
  );
// 获取产品列表
export const getProductListApi = (data) =>
  storeRequest({ cmd: 'GetProductList', payload: data }, { key: 'GetProductList', cache: true });
// 会议每日统计报告
export const getMeetingStatByDayApi = (data) => request('GetMeetingStatByDay', data);
// 会议明细列表
export const getMeetingListApi = (data) => request('GetMeetingList', data);
// 获取会议详情
export const getMeetingDetailApi = (data) => request('GetMeetingDetail', data);
// 查询参会人列表
export const getMeetingAttendantListApi = (data) => request('GetMeetingAttendantList', data);
